import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NormalizeFlareXMLPipe } from './normalize-flare-xml.pipe';

@NgModule({
  declarations: [
    NormalizeFlareXMLPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    NormalizeFlareXMLPipe
  ]
})
export class NormalizeFlareXMLModule { }
